import type { KnowledgeFileDTO } from '@bruno/shared';
import { api, getAccessToken } from './client';
import { API_URL } from '../config';

export const listKnowledgeFiles = (websiteId: string) =>
  api<{ files: KnowledgeFileDTO[] }>(`/v1/websites/${websiteId}/files`);

export async function uploadKnowledgeFile(websiteId: string, file: File): Promise<KnowledgeFileDTO> {
  const form = new FormData();
  form.append('file', file);
  const headers: Record<string, string> = {};
  const token = getAccessToken();
  if (token) headers.Authorization = `Bearer ${token}`;
  const res = await fetch(`${API_URL}/v1/websites/${websiteId}/files`, {
    method: 'POST',
    body: form,
    credentials: 'include',
    headers,
  });
  if (!res.ok) {
    const err = await res.text();
    throw new Error(err || `upload failed (${res.status})`);
  }
  return (await res.json()) as KnowledgeFileDTO;
}

export const deleteKnowledgeFile = (websiteId: string, fileId: string) =>
  api<void>(`/v1/websites/${websiteId}/files/${fileId}`, { method: 'DELETE' });

export const reprocessKnowledgeFile = (websiteId: string, fileId: string) =>
  api<void>(`/v1/websites/${websiteId}/files/${fileId}/reprocess`, { method: 'POST' });
